import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useBaseContext } from 'context/base'

function InputRaporAllType5({ userId, reportGroupId, response }) {
  /* ========================================== Helpers ========================================= */
  const params = useParams()

  /* ====================================== Consume Context ===================================== */
  const { getRequest } = useBaseContext()

  /* ========================================= States ========================================= */
  const [res, setRes] = useState(null)

  /* ======================================== Functions ======================================= */
  async function getValue() {
    let us = localStorage.getItem('user')
    let usj = JSON.parse(us)
    var rsp = await getRequest(
      `get-value-score-by-group?user_id=${userId}&group_id=${reportGroupId}&semester_code=${params.semester}`,
    )

    if (rsp) {
      var ss = {}
      if (rsp.data) {
        var d = rsp.data
        ss = {
          user_id: d.user_id,
          categories_id: d.categories_id,
          categories_type_id: d.categories_type_id,
          report_group_id: d.report_group_id,
          createdBy: d.createdBy,
          updatedBy: d.updatedBy,
          value: JSON.parse(d.value),
          ta_semester_code: d.ta_semester_code,
          profile_id: d.profile_id,
        }
        setRes(ss)
      } else {
        ss = {
          user_id: userId,
          categories_id: null,
          categories_type_id: null,
          report_group_id: reportGroupId,
          createdBy: usj.id,
          updatedBy: usj.id,
          value: {
            sakit: 0,
            ijin: 0,
            alpa: 0,
          },
          ta_semester_code: params.semester,
          profile_id: usj.profile_id,
        }
        setRes(ss)
      }
      response(ss)
    }
  }

  /* ========================================== Effects ========================================= */
  useEffect(() => {
    getValue()
  }, [])

  /* ========================================== Output ========================================== */
  return (
    <div className="table-responsive">
      <table className="table table-bordered">
        <thead>
          <tr>
            <th style={{ width: 200 }}>Keterangan</th>
            <th>Jumlah</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Sakit</td>
            <td>
              <input
                type="text"
                defaultValue={res?.value.sakit}
                onChange={(val) => {
                  var re = res
                  re.value.sakit = val.target.value
                  setRes(res)
                  response(re)
                }}
                className="form-control"
                placeholder={'Sakit'}
              />
            </td>
          </tr>
          <tr>
            <td>Ijin</td>
            <td>
              <input
                type="text"
                defaultValue={res?.value.ijin}
                onChange={(val) => {
                  var re = res
                  re.value.ijin = val.target.value
                  setRes(res)
                  response(re)
                }}
                className="form-control"
                placeholder={'Ijin'}
              />
            </td>
          </tr>
          <tr>
            <td>Alpa (Tanpa Keterangan)</td>
            <td>
              <input
                type="text"
                defaultValue={res?.value.alpa}
                onChange={(val) => {
                  var re = res
                  re.value.alpa = val.target.value
                  setRes(res)
                  response(re)
                }}
                className="form-control"
                placeholder={'Alpa'}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default React.memo(
  InputRaporAllType5,
  (oldProps, newProps) =>
    oldProps.userId === newProps.userId &&
    oldProps.reportGroupId === newProps.reportGroupId,
)
